(function(){
if(window.__mmB)return;var API=window.__mmB={};
var CARD='.kaching-bundles__collection-product',TITLE='.kaching-bundles__collection-product__title';
var cache={},busy=false,timer=null,st={touched:false,manual:false,fails:0,block:null},HTML=document.documentElement;
(function(){var e=document.createElement('style');e.setAttribute('data-mm','p2v-dots');e.textContent='.mm-p2v__dots{margin:8px 0 0}.mm-p2v__dl{margin:0;font-size:14px;line-height:1.3}@media(min-width:750px){html .mm-p2v{grid-template-areas:"bar bar" "dots dots" "thumbs main" "pairs pairs"}html .mm-p2v__dots{grid-area:dots;margin:0 0 6px}}.mm-mdl{margin:10px 0 0}.mm-mdl__lab{font-size:14px;color:#1a1a1a;margin:0 0 8px}.mm-mdl__row{display:flex;gap:10px;padding:2px 2px 4px;overflow-x:auto;scrollbar-width:none}.mm-mdl__row::-webkit-scrollbar{display:none}.mm-mdl__i{flex:0 0 auto;width:64px;height:64px;border-radius:50%;padding:0;border:1px solid #e2dfda;background:#fff;box-sizing:border-box;overflow:hidden;cursor:pointer;-webkit-appearance:none;appearance:none;transition:border-color .15s}.mm-mdl__i img{display:block;width:100%;height:100%;object-fit:cover}.mm-mdl__i:hover{border-color:#1a1a1a}.mm-mdl__i.is-cur{border:2px solid #1b472b}.mm-mdl__i:focus-visible{outline:2px solid #1b472b;outline-offset:2px}.mm-rw--mdl .mm-rw__a{height:64px;top:0}.mm-p1hide-top{display:none !important}.mm-p2top{margin:0 0 4px}.mm-p2top__tag{display:inline-block;margin:0 0 6px;padding:3px 10px;border-radius:20px;background:#1b472b;color:#fff;font-size:11px;font-weight:700;letter-spacing:.02em;text-transform:uppercase}.mm-p2top__h1{margin:0 0 4px}.mm-p2top__sub{margin:0 0 8px}.mm-p2top__price{font-size:2.6rem;font-weight:600;color:#1b472b;display:flex;align-items:baseline;gap:8px}.mm-p2top__was{font-size:1.4rem;color:#8a8a8a;font-weight:400}';document.head.appendChild(e)})();
function $$(s,r){return[].filter.call((r||document).querySelectorAll(s),function(x){return!x.closest('.mm-ghost')})}
function $(s,r){var l=(r||document).querySelectorAll(s);for(var i=0;i<l.length;i++)if(!l[i].closest('.mm-ghost'))return l[i];return null}
function pageHandle(){var h=location.pathname.split('/products/')[1];return h?h.split('?')[0]:''}
function colOfTitle(t){t=(t||'').toLowerCase();return /clog/.test(t)?'clog':/salerno/.test(t)?'salerno':'malibulun'}
function colOfHandle(h){return /^clog-/.test(h)?'clog':/^salerno-/.test(h)?'salerno':'malibulun'}
function cname(t){return t.split(' - ').slice(1).join(' - ')||t}
function prods(col){return cache[col]||(cache[col]=(window.__mmPre&&window.__mmPre[col])||fetch('/collections/'+col+'/products.json?limit=100',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(j){return j.products||[]}).catch(function(){delete cache[col];return[]}))}
function wait(fn,ms){return new Promise(function(res){var t0=Date.now();(function tick(){var v=fn();if(v)return res(v);if(Date.now()-t0>ms)return res(null);setTimeout(tick,16)})()})}
function selBar(){var b=$('.kaching-bundles__bar--selected');return b&&$('.kaching-bundles__bar-collection-products',b)?b:null}
function selIdx(){var b=selBar();return b?$$('.kaching-bundles__bar').indexOf(b):-1}
function cards(){var b=selBar();return b?$$(CARD,b):[]}
function ttl(c){var e=c&&$(TITLE,c);return e?e.textContent.trim():''}
function sizeOf(c){var s=c&&$('select',c);return s?s.value:''}
function setSel(s,v){if(s&&v&&s.value!==v){s.value=v;s.dispatchEvent(new Event('change',{bubbles:true}))}}
async function pick(title,size){
  if(busy)return false;busy=true;HTML.classList.add('mm-quiet');var ok=false;
  try{
    var c=cards()[1];if(!c)return false;
    var rm=$('.kaching-bundles__collection-product__remove-button',c);
    if(rm){rm.click();c=await wait(function(){var x=cards()[1];return x&&$('.kaching-bundles__collection-product__choose-product-button',x)?x:null},1500);if(!c)return false}
    var open=$('.kaching-bundles__collection-product__choose-product-button',c);if(!open)return false;open.click();
    var m=await wait(function(){var x=$('.kaching-bundles__choose-product-modal');return x&&$$('.kaching-bundles__choose-product__product',x).length?x:null},2500);if(!m)return false;
    var card=$$('.kaching-bundles__choose-product__product',m).filter(function(x){return ttl2(x)===title})[0];
    if(!card){var close=$('.kaching-bundles__choose-product-modal__close,[class*=modal__close]',m);if(close)close.click();return false}
    setSel($('select',card),size);
    $('.kaching-bundles__choose-product__product-button',card).click();
    await wait(function(){return!$('.kaching-bundles__choose-product-modal')},2000);
    var c2=await wait(function(){var x=cards()[1];return x&&$('select',x)?x:null},2000);
    if(c2){setSel($('select',c2),size);ok=true}
  }catch(e){}finally{busy=false;HTML.classList.remove('mm-quiet')}
  return ok}
async function openModal(){
  if(busy)return;st.manual=true;var c=cards()[1];var rm=c&&$('.kaching-bundles__collection-product__remove-button',c);
  if(rm){rm.click();c=await wait(function(){var x=cards()[1];return x&&$('.kaching-bundles__collection-product__choose-product-button',x)?x:null},1500)}
  var open=c&&$('.kaching-bundles__collection-product__choose-product-button',c);if(open)open.click()}
async function pickP2(p){var G=window.__mmG,held=G&&G.hold(1,p);st.touched=true;st.title=p.title;st.size=sizeOf(cards()[1])||sizeOf(cards()[0]);var pv=openPv(p.handle);var ok=await pick(p.title,st.size);if(!ok){st.touched=false;closePv()}try{await pv}catch(e){}try{await render()}catch(e){}schedule();if(held)await G.release(p.handle)}
function wasTwo(){return st.wasTwo!==false}
function relabel(two){var w=two?'Pair 1 colour: ':'Colour: ',d=$('.mm-dots');if(d&&d.classList.contains('mm-two')!==two)d.classList.toggle('mm-two',two);
  [$('.mm-dots__lab'),$('.mm-col__label')].forEach(function(l){var f=l&&l.firstChild;if(f&&f.nodeType===3&&f.nodeValue!==w)f.nodeValue=w});
  var s0=$('.mm-sg__title');if(s0){var v=two?'Size scale':'Select Size';if(s0.textContent!==v)s0.textContent=v}}
function ttl2(x){var e=$('.kaching-bundles__choose-product__product-title',x);return e?e.textContent.trim():''}

/* ---------- colour dots (replace the empty "Write Review" row) ---------- */
var HEX={'Black':['#1a1a1a'],'White':['#f4f4f1'],'Cream':['#e9e2cf'],'Sand':['#bfa27b'],'Light Brown':['#a6794a'],'Dark Brown':['#4a2f24'],'Brown':['#6a4a37'],'Caramel':['#b0692a'],'Light Brown & Caramel':['#a6794a','#b0692a'],'Grey':['#6b6e72'],'Light Grey':['#a7a8a8'],'Dark Grey':['#56585b'],'Grey & Cream':['#6b6e72','#e9e2cf'],'Blue':['#33507a'],'Dark Blue':['#26314f'],'Aqua Green':['#45b8a8'],'Matcha Green':['#a3a67f'],'Moss Green':['#6d6a4c'],'Green':['#55684a'],'Chestnut Red':['#94473a'],'Red':['#b3282d'],'Pink':['#e2b1b3'],'Silver':['#c5c8cd']};
function dotStyle(n){var h=HEX[n]||['#cfcfcf'];return '--c1:'+h[0]+';--c2:'+(h[1]||h[0])}
async function ensureDots(){try{await ensureDots0()}finally{HTML.classList.add('mm-dots-ok')}}
async function ensureDots0(){
  var h=pageHandle();if(!h)return;
  var ex=$('.mm-dots');if(ex&&ex.getAttribute('data-h')===h)return;
  var list=await prods(colOfHandle(h));if(!list.length||h!==pageHandle())return;
  var me=list.filter(function(p){return p.handle===h})[0];if(!me)return;
  var fam=me.title.split(' - ')[0];
  var fl=list.filter(function(p){return p.title.split(' - ')[0]===fam});if(fl.length<2)return;
  ex=$('.mm-dots');if(ex){if(ex.getAttribute('data-h')===h)return;ex.remove()}
  var rv=$('.areviews_header_stars'),wrap=rv&&rv.closest('.shopify-app-block'),sub=$('.mm-sub');
  var par=wrap?wrap.parentNode:(sub&&sub.parentNode),ref=wrap||(sub&&sub.nextSibling);if(!par)return;
  var two0=wasTwo();var box=document.createElement('div');box.className='mm-dots'+(two0?' mm-two':'');box.setAttribute('data-h',h);
  var lab=document.createElement('p');lab.className='mm-dots__lab';lab.appendChild(document.createTextNode(two0?'Pair 1 colour: ':'Colour: '));
  var b=document.createElement('strong');b.textContent=cname(me.title);lab.appendChild(b);
  var hd=document.createElement('div');hd.className='mm-dots__head';hd.appendChild(lab);var pc=document.createElement('span');pc.className='mm-dots__pic';
  if(me.images&&me.images[0]){var pi=document.createElement('img');pi.src=imu(me.images[0].src,120);pi.alt='';pi.width=104;pi.height=104;pc.appendChild(pi)}hd.appendChild(pc);box.appendChild(hd);
  var row=document.createElement('div');row.className='mm-dots__row';
  fl.forEach(function(p){var n=cname(p.title);var d=document.createElement('button');d.type='button';d.className='mm-dot'+(p.handle===h?' is-cur':'');
    d.setAttribute('aria-label',n);d.title=n;d.setAttribute('aria-pressed',p.handle===h?'true':'false');d.setAttribute('style',dotStyle(n));
    d.addEventListener('click',function(e){e.preventDefault();if(p.handle===pageHandle())return;var a=$('a.mm-col__item[href$="/products/'+p.handle+'"]');if(a)a.click();else location.href='/products/'+p.handle});
    d.addEventListener('pointerover',function(){var a=$('a.mm-col__item[href$="/products/'+p.handle+'"]');if(a)a.dispatchEvent(new Event('pointerover',{bubbles:true}))},{passive:true});
    row.appendChild(d)});
  box.appendChild(row);par.insertBefore(box,ref||null);HTML.classList.add('mm-hasdots')}


async function ensureTiles(){
  var c=$('.mm-col');if(!c||c.querySelector('.mm-col__item'))return;
  var h=pageHandle();if(!h)return;var col=colOfHandle(h);if(col==='malibulun')return;
  var list=await prods(col);if(!list||list.length<2||h!==pageHandle())return;
  c=$('.mm-col');if(!c||c.querySelector('.mm-col__item'))return;
  var base=location.pathname.split('/products/')[0];
  var lab=document.createElement('p');lab.className='mm-col__label';lab.appendChild(document.createTextNode('Colour: '));var stg=document.createElement('strong');lab.appendChild(stg);
  var row=document.createElement('div');row.className='mm-col__row';
  list.forEach(function(p){var nm=cname(p.title);var a=document.createElement('a');a.className='mm-col__item'+(p.handle===h?' is-current':'');a.href=base+'/products/'+p.handle;a.title=nm;a.setAttribute('aria-label',nm);
    if(p.handle===h){a.setAttribute('aria-current','true');stg.textContent=nm}
    var im=p.images&&p.images[0];if(im){var i=document.createElement('img');i.src=imu(im.src,160);i.alt=nm;i.width=160;i.height=160;a.appendChild(i)}row.appendChild(a)});
  c.innerHTML='';c.appendChild(lab);c.appendChild(row)}

/* ---------- photos of pair 2 (shown in the gallery, pair 1 is not touched) ---------- */
var pcache={};
function pjson(h){return pcache[h]||(pcache[h]=fetch('/products/'+h+'.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw 0;return r.json()}).catch(function(){delete pcache[h];return null}))}
function warm2(h){pjson(h).then(function(j){if(j&&j.images&&j.images[0]){var i=new Image();i.src=imu(j.images[0],900);pw.push(i);if(pw.length>30)pw.shift()}})}
var pw=[];
function imu(s,w){s=String(s).replace(/^\/\//,'https://');return s+(s.indexOf('?')>-1?'&':'?')+'width='+w}
function predec(u){return new Promise(function(res){var i=new Image();i.src=u;var t=setTimeout(res,1500);(i.decode?i.decode():Promise.reject()).then(function(){clearTimeout(t);res()},function(){clearTimeout(t);res()})})}
function closePv(){var p=$('.mm-p2v');if(p)p.remove();var g=$('media-gallery');if(g)g.classList.remove('mm-pv-hide');ensureP2Top(false)}
function goTo(el,off){var t=el.getBoundingClientRect().top;if(t<0||t>window.innerHeight*.6)window.scrollTo({top:window.pageYOffset+t-(off||70),behavior:'smooth'})}
function goToTop(el,off){if(!el)return;var t=el.getBoundingClientRect().top;window.scrollTo({top:window.pageYOffset+t-(off||0),behavior:'smooth'})}
function goToCard(i,off){var c=cards()[i];if(c){goTo(c,off);return}var k=$('.kaching-bundles__block');if(k)goTo(k,off)}
function isMobileMM(){return matchMedia('(max-width:749px)').matches}
/* while the Pair 2 photo viewer is open, the TOP of the page (H1 title, subtitle, price) shows Pair 2's
   info instead of Pair 1's — Pair 1's own title/subtitle/price are hidden, not just labelled, and a
   "Pair 2 · free" block with Pair 2's title/subtitle and a FREE price takes their place. Closing the
   viewer (any restore path) removes the block and un-hides Pair 1's original title/subtitle/price. */
var SUBMAP={'Maibulun Suede Sandal':'Two-strap footbed sandal','Maibulun Leather Sandal':'Two-strap footbed sandal','Clog':'Slip-on footbed clog','Salerno Suede Sandal':'Two-strap footbed sandal'};
function origPriceText(){var p=$('.product-page-price');if(!p)return'';var el=$('.price-item--regular',p)||$('.price-item',p);var t=el?el.textContent:p.textContent;var m=(t||'').match(/[€£$]\s?[\d.,]+/);return m?m[0]:''}
function ensureP2Top(on,data){
  var wrap=$('.product__title');if(!wrap)return;
  var sub=$('.mm-sub');var price=$('.product-page-price');
  var ex=$('.mm-p2top');
  if(!on){
    if(ex)ex.remove();
    wrap.classList.remove('mm-p1hide-top');
    if(sub)sub.classList.remove('mm-p1hide-top');
    if(price)price.classList.remove('mm-p1hide-top');
    return}
  wrap.classList.add('mm-p1hide-top');
  if(sub)sub.classList.add('mm-p1hide-top');
  if(price)price.classList.add('mm-p1hide-top');
  if(ex){
    var h=$('.mm-p2top__h1',ex);if(h&&data&&data.title&&h.textContent!==data.title)h.textContent=data.title;
    var s=$('.mm-p2top__sub',ex);if(s&&data&&s.textContent!==data.sub)s.textContent=data.sub;
    return}
  var box=document.createElement('div');box.className='mm-p2top';
  var tag=document.createElement('span');tag.className='mm-p2top__tag';tag.textContent='Pair 2 · free';box.appendChild(tag);
  var h1=document.createElement('h1');h1.className='h1 mm-p2top__h1';h1.textContent=data&&data.title||'';box.appendChild(h1);
  var sb=document.createElement('p');sb.className='mm-sub mm-p2top__sub';sb.textContent=data&&data.sub||'';box.appendChild(sb);
  var pr=document.createElement('div');pr.className='mm-p2top__price';
  var free=document.createElement('span');free.className='mm-p2top__free';free.textContent='FREE';pr.appendChild(free);
  if(data&&data.was){var was=document.createElement('s');was.className='mm-p2top__was';was.textContent=data.was;pr.appendChild(was)}
  box.appendChild(pr);
  wrap.parentNode.insertBefore(box,wrap)}
async function openPv(h){
  var g=$('media-gallery');if(!g)return;var j=await pjson(h);
  var fam2=(j&&j.title||'').split(' - ')[0];var fl2=j?(await prods(colOfHandle(h))).filter(function(p){return p.title.split(' - ')[0]===fam2}):[];
  if(!j||!j.images||!j.images.length||selIdx()!==1)return;
  await predec(imu(j.images[0],900));if(selIdx()!==1)return;
  closePv();
  var pn=document.createElement('div');pn.className='mm-p2v';pn.setAttribute('data-h',h);pn.setAttribute('role','region');pn.setAttribute('aria-label','Photos of pair 2');
  var bar=document.createElement('div');bar.className='mm-p2v__bar';
  var tag=document.createElement('span');tag.className='mm-p2v__tag';tag.textContent='Pair 2 · free';
  var nm=document.createElement('span');nm.className='mm-p2v__name';nm.textContent=j.title;
  var back=document.createElement('button');back.type='button';back.className='mm-p2v__back';back.textContent='Back to pair 1 photos';
  bar.appendChild(tag);bar.appendChild(nm);bar.appendChild(back);pn.appendChild(bar);
  var main=document.createElement('div');main.className='mm-p2v__main';main.setAttribute('tabindex','0');
  var th=document.createElement('div');th.className='mm-p2v__thumbs';var tb=[];
  j.images.forEach(function(s,i){
    var im=document.createElement('img');im.src=imu(s,900);im.alt=j.title+' – photo '+(i+1);im.width=900;im.height=900;if(i>1)im.loading='lazy';main.appendChild(im);
    var b=document.createElement('button');b.type='button';b.className=i?'':'on';b.setAttribute('aria-label','Photo '+(i+1));
    var t=document.createElement('img');t.src=imu(s,124);t.alt='';t.width=62;t.height=62;if(i>7)t.loading='lazy';b.appendChild(t);
    b.addEventListener('click',function(){main.scrollTo({left:i*main.clientWidth,behavior:'smooth'})});tb.push(b);th.appendChild(b)});
  main.addEventListener('scroll',function(){var i=Math.round(main.scrollLeft/(main.clientWidth||1));tb.forEach(function(b,k){b.classList.toggle('on',k===i)})},{passive:true});
  pn.appendChild(main);if(j.images.length>1)pn.appendChild(th);
  if(fl2.length>1){var dw=document.createElement('div');dw.className='mm-p2v__dots';
    var dl=document.createElement('p');dl.className='mm-p2v__dl';dl.appendChild(document.createTextNode('Pair 2 colour: '));var ds=document.createElement('strong');ds.textContent=cname(j.title);dl.appendChild(ds);dw.appendChild(dl);
    var dr=document.createElement('div');dr.className='mm-dots__row';
    fl2.forEach(function(p){var n=cname(p.title);var d=document.createElement('button');d.type='button';d.className='mm-dot'+(p.handle===h?' is-cur':'');d.title=n;d.setAttribute('aria-label',n);d.setAttribute('aria-pressed',p.handle===h?'true':'false');d.setAttribute('style',dotStyle(n));
      d.addEventListener('click',function(e){e.preventDefault();if(p.handle!==h)pickP2(p)});
      d.addEventListener('pointerover',function(){warm2(p.handle)},{passive:true});dr.appendChild(d)});
    dw.appendChild(dr);pn.appendChild(dw)}
  var pairs=document.createElement('button');pairs.type='button';pairs.className='mm-p2v__pairs';pairs.textContent='↓ Back to my pairs';pn.appendChild(pairs);
  back.addEventListener('click',function(){closePv();if(isMobileMM()){goToTop($('media-gallery'),70)}else goToCard(0,84)});
  pairs.addEventListener('click',function(){var k=$('.kaching-bundles__block');if(k)window.scrollTo({top:window.pageYOffset+k.getBoundingClientRect().top-12,behavior:'smooth'})});
  g.classList.add('mm-pv-hide');g.parentNode.insertBefore(pn,g);
  ensureP2Top(true,{title:fam2||j.title,sub:(SUBMAP[fam2]||(($('.mm-sub')||{}).textContent||'')),was:origPriceText()});
  if(isMobileMM())goToTop(pn,70);else goToCard(1,84)}

/* ---------- model picker (round photos): switch Pair 2 between Maibulun Suede / Maibulun Leather / Clog / Salerno ---------- */
var FAMORDER=['Maibulun Suede Sandal','Maibulun Leather Sandal','Clog','Salerno Suede Sandal'];
function shortFam(f){return f.replace(/\s+Sandal$/,'')}
function famRep(list){var b=list.filter(function(p){return cname(p.title)==='Black'})[0];return b||list[0]}
async function famList(){
  var cols=['malibulun','clog','salerno'];
  var lists=await Promise.all(cols.map(prods));
  var all=[].concat.apply([],lists);
  var byFam={};
  all.forEach(function(p){var f=p.title.split(' - ')[0];(byFam[f]=byFam[f]||[]).push(p)});
  var fams=Object.keys(byFam);
  fams.sort(function(a,b){var ia=FAMORDER.indexOf(a),ib=FAMORDER.indexOf(b);if(ia<0)ia=99;if(ib<0)ib=99;return ia-ib||a.localeCompare(b)});
  return fams.map(function(f){return famRep(byFam[f])}).filter(Boolean)}
function mArrows(r){var w=r.parentNode;if(!w||!w.classList.contains('mm-rw'))return;var m=r.scrollWidth-r.clientWidth;w.classList.toggle('mm-rw--l',r.scrollLeft>4);w.classList.toggle('mm-rw--r',m>4&&r.scrollLeft<m-4)}
function mdlWrap(row){
  if(row.parentNode.classList.contains('mm-rw'))return;
  var w=document.createElement('div');w.className='mm-rw mm-rw--mdl';
  row.parentNode.insertBefore(w,row);w.appendChild(row);
  if(!matchMedia('(max-width:749px)').matches)return;
  ['l','r'].forEach(function(k){
    var b=document.createElement('button');b.type='button';b.className='mm-rw__a mm-rw__a--'+k;b.setAttribute('aria-label',k==='l'?'Previous models':'More models');
    b.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'+(k==='l'?'M15 5l-7 7 7 7':'M9 5l7 7-7 7')+'"/></svg>';
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();row.scrollBy({left:(k==='l'?-1:1)*Math.max(120,row.clientWidth*.75),behavior:'smooth'})});
    w.appendChild(b)});
  row.addEventListener('scroll',function(){mArrows(row)},{passive:true});
  mArrows(row)}
async function ensureModels(card,curTitle){
  if(!card||!curTitle)return;
  var fam=curTitle.split(' - ')[0];
  var key='m|'+fam;var ex=$('.mm-mdl',card);if(ex&&ex.getAttribute('data-k')===key)return;
  var fams=(await famList()).filter(function(p){return p.title.split(' - ')[0]!==fam});if(!fams.length)return;
  ex=$('.mm-mdl',card);if(ex){if(ex.getAttribute('data-k')===key)return;ex.remove()}
  var box=document.createElement('div');box.className='mm-mdl';box.setAttribute('data-k',key);
  var lab=document.createElement('p');lab.className='mm-mdl__lab';lab.appendChild(document.createTextNode('Other models: '));box.appendChild(lab);
  var row=document.createElement('div');row.className='mm-mdl__row';
  fams.forEach(function(p){var f=p.title.split(' - ')[0];var x=document.createElement('button');x.type='button';x.className='mm-mdl__i';var sf=shortFam(f);x.title=sf;x.setAttribute('aria-label',sf);
    var im=p.images&&p.images[0];if(im){var i=document.createElement('img');i.src=imu(im.src,140);i.alt=sf;i.loading='lazy';i.width=64;i.height=64;x.appendChild(i)}
    x.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();pickP2(p)});
    x.addEventListener('pointerover',function(){warm2(p.handle)},{passive:true});
    row.appendChild(x)});
  box.appendChild(row);card.appendChild(box);mdlWrap(row)}

function strip(card,kind,list,curTitle,onPick,n){
  var key=kind+'|'+n+'|'+curTitle+'|'+list.length;var ex=$('.mm-swb',card);if(ex&&ex.getAttribute('data-k')===key)return;if(ex)ex.remove();
  var fam=(curTitle||'').split(' - ')[0];if(fam)list=list.filter(function(p){return p.title.split(' - ')[0]===fam});
  if(list.length<2)return;
  var box=document.createElement('div');box.className='mm-swb';box.setAttribute('data-k',key);
  var lab=document.createElement('p');lab.className='mm-swb__lab';lab.appendChild(document.createTextNode(kind==='p2'?'Pair 2 colour: ':(n===1?'Pair 1 colour: ':'Colour: ')));var b=document.createElement('strong');b.textContent=curTitle?cname(curTitle):'choose below';lab.appendChild(b);box.appendChild(lab);
  if(kind==='p2'&&curTitle){var cur=list.filter(function(p){return p.title===curTitle})[0];if(cur){var ph=document.createElement('button');ph.type='button';ph.className='mm-swb__ph';ph.textContent='View photos';ph.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openPv(cur.handle)});lab.appendChild(ph)}}
  var g=document.createElement('div');g.className='mm-sw';
  list.forEach(function(p){var n=cname(p.title);var x=document.createElement('button');x.type='button';x.className='mm-sw__i'+(p.title===curTitle?' is-cur':'');x.title=n;x.setAttribute('aria-label',n);x.setAttribute('data-h',p.handle);
    var im=p.images&&p.images[0];if(im){var i=document.createElement('img');i.src=im.src+(im.src.indexOf('?')>-1?'&':'?')+'width=100';i.alt=n;i.loading='lazy';i.width=42;i.height=42;x.appendChild(i)}
    x.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(p.title!==curTitle)onPick(p);else if(kind==='p2')openPv(p.handle)});
    x.addEventListener('pointerover',function(){if(kind==='p2')warm2(p.handle);if(kind==='p1'){var a=$('a.mm-col__item[href$="/products/'+p.handle+'"]');if(a)a.dispatchEvent(new Event('pointerover',{bubbles:true}))}},{passive:true});
    g.appendChild(x)});
  box.appendChild(g);
  if(kind==='p2'){var mo=document.createElement('button');mo.type='button';mo.className='mm-swb__more';mo.textContent='Choose a different model';mo.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openModal()});box.appendChild(mo)}
  card.appendChild(box)}
async function render(){
  var bl=$('.kaching-bundles__block');
  $$('.kaching-bundles__bar').forEach(function(b,i){if(b.getAttribute('data-mm-n')!==String(i))b.setAttribute('data-mm-n',i)});
  var idx=selIdx(),inb=idx>-1;if($$('.kaching-bundles__bar').length)HTML.classList.toggle('mm-inb',inb);
  ensureTiles().catch(function(){});ensureDots().catch(function(){});if($('.mm-p2v')&&idx!==1)closePv();
  if(idx>-1){st.wasTwo=idx===1;relabel(idx===1)}
  var st0=$('.mm-sg__title');if(st0&&idx>-1){var want=inb?'Size scale':'Select Size';if(st0.textContent!==want)st0.textContent=want}
  var bs=$$('.kaching-bundles__bar');
  bs.forEach(function(bar,i){var t=$('.kaching-bundles__bar-title',bar),s=$('.kaching-bundles__bar-subtitle',bar);
    if(t&&t.firstChild&&/^[€£$]/.test(t.textContent.trim())&&bs.length===2){t.firstChild.nodeValue=i===0?'1 pair':'2 pairs'}
    if(s&&s.firstChild&&bs.length===2&&i===1&&s.firstChild.nodeValue!=='Buy 1, get 1 free'){s.firstChild.nodeValue='Buy 1, get 1 free'}});
  if(!inb||busy)return;
  var cs=cards();if(!cs.length)return;
  if(st.block!==bl){st.block=bl;st.fails=0}
  var c1=cs[0],c2=idx===1?cs[1]:null;var t1=ttl(c1),t2=ttl(c2);
  if(t2&&st.manual){st.manual=false;st.touched=true;st.title=t2;st.size=sizeOf(c2)}
  if(idx===1&&c2&&!t2&&t1&&st.fails<2&&!st.manual){
    var size=st.touched&&st.size?st.size:sizeOf(c1);var title=st.touched&&st.title?st.title:t1;
    var ok=await pick(title,size);if(!ok)st.fails++;schedule();return}
  var pl1=await prods(colOfHandle(pageHandle()));
  strip(c1,'p1',pl1,t1,function(p){
    var a=$('a.mm-col__item[href$="/products/'+p.handle+'"]');
    if(a)a.click();else location.href='/products/'+p.handle},idx);
  if(c2&&t2){var pl2=await prods(colOfTitle(t2));
    strip(c2,'p2',pl2,t2,pickP2,idx);
    ensureModels(c2,t2).catch(function(){});
    var cp=$('.mm-p2v');if(cp){var m2=pl2.filter(function(p){return p.title===t2})[0];if(m2&&cp.getAttribute('data-h')!==m2.handle)openPv(m2.handle)}}
}
var rIn=false,rAgain=false,lastRun=0;
async function runRender(){if(rIn){rAgain=true;return}rIn=true;try{await render()}catch(e){}finally{rIn=false;lastRun=Date.now();if(rAgain){rAgain=false;schedule()}}}
function schedule(){if(timer)return;timer=setTimeout(function(){timer=null;runRender()},Math.max(0,60-(Date.now()-lastRun)))}
document.addEventListener('change',function(e){var s=e.target;if(s&&s.tagName==='SELECT'){var c=s.closest&&s.closest(CARD);var cs=cards();if(c&&selIdx()===1&&cs[1]===c){st.touched=true;st.title=ttl(c);st.size=s.value}}schedule()},true);
document.addEventListener('click',function(e){var m=e.target.closest&&e.target.closest('.kaching-bundles__bar--selected .kaching-bundles__bar-main');if(m){e.preventDefault();e.stopPropagation();return}schedule()},true);
new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
schedule();
API.prods=prods;API.ensureDots=ensureDots;API.ensureTiles=ensureTiles;API.schedule=schedule;API.colOfHandle=colOfHandle;API.relabel=relabel;API.wasTwo=wasTwo;
/* cart drawer: the grouped-bundle label script (theme setting) is written in Portuguese; show English */
var TR=[[/^Kit\s*•\s*(\d+)\s*itens$/,'Bundle • $1 items'],[/^Ver itens$/,'View items'],[/^Ocultar itens$/,'Hide items']];
function tr(){$$('.bundle-summary__title,.bundle-summary__toggle').forEach(function(e){var t=e.textContent.trim();TR.forEach(function(r){if(r[0].test(t))e.textContent=t.replace(r[0],r[1])})})}
new MutationObserver(tr).observe(document.body,{childList:true,subtree:true,characterData:true});tr();
})();
(function () {
  function cents(text) {
    var match = (text || '').match(/\d[\d\s\u00a0.,]*[.,]\d{2}/);
    if (!match) return null;
    var value = match[0].replace(/[\s\u00a0]/g, '');
    var separator = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    var whole = value.slice(0, separator).replace(/\D/g, '');
    var fraction = value.slice(separator + 1);
    return Number(whole) * 100 + Number(fraction);
  }

  function displayPrice(example, amount) {
    var match = (example || '').match(/\d[\d\s\u00a0.,]*[.,]\d{2}/);
    if (!match) return example;
    var decimal = match[0].slice(-3, -2);
    var locale = decimal === ',' ? 'de-DE' : 'en-US';
    var formatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount / 100);
    return example.replace(match[0], formatted);
  }

  function syncPrices() {
    document.querySelectorAll('.kaching-bundles__block').forEach(function (block) {
      var bars = block.querySelectorAll('.kaching-bundles__bar');
      if (bars.length !== 2) return;
      var one = bars[0].querySelector('.kaching-bundles__bar-price');
      var two = bars[1].querySelector('.kaching-bundles__bar-price');
      var original = bars[1].querySelector('.kaching-bundles__bar-full-price');
      var offer = bars[1].querySelector('.kaching-bundles__bar-subtitle');
      if (!one || !two || !original || !offer || !/buy 1, get 1 free/i.test(offer.textContent)) return;
      var currentOne = cents(one.textContent);
      // Keep the first pair's real price even after replacing its label.
      var first = one.dataset.mmDisplayedCents === String(currentOne) && one.dataset.mmOriginalCents
        ? Number(one.dataset.mmOriginalCents)
        : currentOne;
      var combined = cents(original.textContent);
      if (first === null || combined === null || combined < first) return;
      var second = combined - first;
      var higher = Math.max(first, second);
      var twoSelected = bars[1].classList.contains('kaching-bundles__bar--selected');
      var shownOne = twoSelected ? higher : first;
      var oneLabel = displayPrice(one.textContent, shownOne);
      var twoLabel = displayPrice(two.textContent, higher);
      if (one.textContent !== oneLabel) one.textContent = oneLabel;
      if (two.textContent !== twoLabel) two.textContent = twoLabel;
      one.dataset.mmOriginalCents = String(first);
      one.dataset.mmDisplayedCents = String(shownOne);
      var secondPaid = second > first;
      bars[1].classList.toggle('mm-second-pair-paid', secondPaid);
      if (!bars[1].classList.contains('kaching-bundles__bar--selected')) return;
      var saving = document.querySelector('.kaching-bundles-savings-summary__value');
      if (saving) {
        var saved = displayPrice(saving.textContent, Math.min(first, second));
        if (saving.textContent !== saved) saving.textContent = saved;
      }

      document.querySelectorAll('.mm-p2v__tag, .mm-p2top__tag').forEach(function (tag) {
        var label = secondPaid ? 'Pair 2 · you pay' : 'Pair 2 · free';
        if (tag.textContent !== label) tag.textContent = label;
      });
      var viewerPrice = document.querySelector('.mm-p2top__free');
      if (viewerPrice) {
        var shown = secondPaid ? displayPrice(one.textContent, second) : 'FREE';
        if (viewerPrice.textContent !== shown) viewerPrice.textContent = shown;
      }
      var viewerWas = document.querySelector('.mm-p2top__was');
      if (viewerWas) {
        viewerWas.hidden = secondPaid;
        if (!secondPaid) {
          var originalSecond = displayPrice(one.textContent, second);
          if (viewerWas.textContent !== originalSecond) viewerWas.textContent = originalSecond;
        }
      }

      document.querySelectorAll('.kaching-bundles__choose-product__product-price-container').forEach(function (item) {
        var itemPrice = item.querySelector('.kaching-bundles__choose-product__product-price');
        var listPrice = item.querySelector('.kaching-bundles__choose-product__product-compare-at-price');
        if (itemPrice && listPrice && itemPrice.textContent !== listPrice.textContent) {
          itemPrice.textContent = listPrice.textContent;
        }
      });
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncPrices();
    });
  }

  function start() {
    var root = document.querySelector('product-info');
    if (!root) return;
    new MutationObserver(schedule).observe(root, { childList: true, characterData: true, attributes: true, attributeFilter: ['class'], subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* Related products, BOGO sticky bar and scroll-to-top spacing. */
(function () {
  function initRelated() {
    document.querySelectorAll('product-recommendations').forEach(function(section) {
      var grid = section.querySelector('.product-grid');
      if (!grid || grid.dataset.mmArrowsReady) return;
      grid.dataset.mmArrowsReady = 'true';
      var arrows = section.querySelectorAll('.mm-related-arrow');
      function update() {
        var max = grid.scrollWidth - grid.clientWidth;
        arrows.forEach(function(button) {
          button.disabled = max < 2 || (Number(button.dataset.direction) < 0 ? grid.scrollLeft <= 2 : grid.scrollLeft >= max - 2);
        });
      }
      arrows.forEach(function(button) {
        button.addEventListener('click', function() {
          var card = grid.querySelector('.grid__item');
          var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(grid).columnGap || 0) : grid.clientWidth * .8;
          grid.scrollBy({left: Number(button.dataset.direction) * step, behavior: 'smooth'});
        });
      });
      grid.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      update();
    });
  }
  function updateSticky() {
    var sticky = document.querySelector('.sticky-atc');
    if (!sticky) return;
    var bar = document.querySelector('.kaching-bundles__bar--selected');
    var title = sticky.querySelector('.sticky-atc__title');
    var price = sticky.querySelector('.sticky-atc__price');
    if (bar) {
      var bundle = bar.parentElement && bar.parentElement.querySelectorAll('.kaching-bundles__bar').length === 2;
      var isTwo = bundle && bar === bar.parentElement.querySelectorAll('.kaching-bundles__bar')[1];
      var amount = bar.querySelector('.kaching-bundles__bar-price');
      if (title) {
        var label = isTwo ? 'Buy 1 Get 1 free' : (title.dataset.mmOriginalTitle || title.textContent.trim());
        if (!title.dataset.mmOriginalTitle) title.dataset.mmOriginalTitle = title.textContent.trim();
        if (title.textContent.trim() !== label) title.textContent = label;
        title.classList.toggle('mm-bogo-title', isTwo);
      }
      if (price && amount && amount.textContent.trim()) {
        var shown = amount.textContent.trim();
        if (price.textContent.trim() !== shown) price.textContent = shown;
      }
    }
    var rect = sticky.getBoundingClientRect();
    var visible = rect.height > 0 && rect.bottom > innerHeight - 3 && rect.top < innerHeight && getComputedStyle(sticky).visibility !== 'hidden' && getComputedStyle(sticky).opacity !== '0';
    document.documentElement.classList.toggle('mm-sticky-visible', visible);
    if (visible) document.documentElement.style.setProperty('--mm-sticky-height', Math.ceil(rect.height) + 'px');
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function() {pending = false;initRelated();updateSticky();});
  }
  function start() {
    new MutationObserver(schedule).observe(document.body,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['class','style']});
    window.addEventListener('scroll', schedule,{passive:true});
    window.addEventListener('resize',schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
